import { Injectable } from '@angular/core';

declare let ga:Function;

@Injectable({
  providedIn: 'root'
})

export class GoogleAnalyticsService {

  constructor() { }

  public eventEmitter(eventCategory: string,
                      eventAction: string,
                      eventLabel?: string,
                      eventValue?: string) {
    ga('send', 'event', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }

  public initializeGA(id,username){
    ga('create', id,'auto');
    ga('set','userId',username);
    ga('send', 'pageview');
  }

  public setAnalyticsForRoutes(page){
    ga('set', 'page', page);
    ga('send', 'pageview');
  }
}
